// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-participant {
  display: inline-flex;
  align-self: flex-start;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 4px;
  margin-right: 12px;
  font-size: var(--font-big);
  color: var(--color-highlight-darker);
}
.icon-check {
  font-size: 100px;
}
.select-disabled-spot {
  display: none;
}
.result-success-spot {
  font-size: 24px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 100%;
}
.result-success-spot .result-success-spot__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-width: 600px;
}
.result-success-spot .result-success-spot__content .result-success-spot__description {
  font-size: 16px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.result-success-spot .result-success-spot__button {
  margin-top: 20px;
}
@media screen and (max-width: 768px) {
  .box_content-sucess-spot {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
}
.result-success-spot .result-success-spot__content .result-success-spot__description {
  font-size: 14px;
  text-align: justify;
  text-justify: inter-word;
}
.vert-title-form-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.box-product-spot {
  margin-top: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-neutral-light);
  border-radius: var(--border-radius-primary);
  padding: 14px;
}
.spot-page-datepicker .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel {
  width: 290px;
}
.spot-page-datepicker .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel .ant-picker-body {
  padding: var(--spacing-small);
}
.spot-page-datepicker .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel .ant-picker-header .ant-picker-header-view {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-extra-small);
}
.box-value-spot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: var(--spacing-extra-small) 0;
  border: 1px solid var(--color-neutral-light);
  border-radius: var(--border-radius-primary);
  background-color: var(--color-neutral-light-lighter) !important;
  padding: var(--spacing-small);
}
.box-value-hierarchy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 1px solid var(--color-neutral-light);
  border-radius: var(--border-radius-primary);
  background-color: var(--color-neutral-light-lighter) !important;
  padding: var(--spacing-small);
}
.box-value-hierarchy .shipping-value .free {
  font-weight: 500;
  color: var(--color-highlight);
}
.box-buttons-spot-submit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: var(--spacing-extra-small) 0;
  padding: var(--spacing-small);
  gap: var(--spacing-small);
}
.box-inputs {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.box-inputs .error {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}
.box-graft {
  margin-bottom: 62px;
}
.box-show-endereco-entrega-spot {
  margin: 6px 0px;
  row-gap: var(--spacing-small);
}
.vert-radio.ant-radio-wrapper {
  align-items: center;
  gap: 8px;
  text-align: center;
  font-size: var(--font-paragraph);
}
.vert-radio.ant-radio-wrapper .ant-radio + span {
  margin-top: unset !important;
  height: unset !important;
}
.vert-radio.ant-radio-wrapper .ant-radio .ant-radio-inner {
  width: 16px;
  height: 16px;
  border-width: var(--border-width);
}
.vert-radio.ant-radio-wrapper .ant-radio .ant-radio-inner::after {
  width: 8px;
  height: 8px;
  border-width: var(--border-width);
  background-color: #25cc6e !important;
  transform: scale(1) !important;
  border-radius: 50px !important;
}
.vert-modal-product-spot {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.vert-modal-product-spot__footer {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
@media screen and (max-width: 768px) {
  .vert-modal-product-spot__footer {
    flex-direction: column;
    gap: 10px;
  }
}
.vert-product-table-spot {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}
@media screen and (max-width: 768px) {
  .vert-product-table-spot {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }
}
.vert-product-table-spot-value {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}
@media screen and (max-width: 768px) {
  .vert-modal-product-spot__footer {
    flex-direction: column;
    gap: 10px;
  }
}
.vert-input-number-spot {
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: var(--border-radius-primary);
  border: 1px solid var(--color-border);
  padding: 4px var(--spacing-small);
  position: relative;
}
.vert-input-number-spot .shrink-label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 8px 16px 4px 16px;
  font-size: 12px;
  transform: translateY(0);
  transition: all 0.3s ease-out;
  line-height: inherit;
  z-index: 2;
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  color: var(--color-neutral-light);
}
.vert-input-number-spot .vert-input-label-spot {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  color: var(--color-neutral-light);
  display: flex;
  align-items: center;
}
.vert-input-number-spot .vert-input-label-spot .asterisk {
  color: var(--color-error);
}
.vert-input-number-spot input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  padding-top: 24px;
  color: var(--color-neutral-dark);
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
}
.vert-input-number-spot input::placeholder {
  color: #d5d5e7;
  font-weight: 500;
}
.vert-input-container input:disabled,
.vert-input-container:disabled {
  background-color: var(--color-neutral-light-darker);
  border: none;
  color: var(--color-button-text);
  cursor: not-allowed;
  overflow: hidden;
}
.vert-input-container input:disabled::placeholder,
.vert-input-container:disabled::placeholder {
  color: #b9bece;
}
.vert-select-fornecedor {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
}
.div-button-fornecedor-spot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: var(--spacing-small) 0;
}
@media (max-width: 768px) {
  .box-product-spot {
    padding: 10px;
    border-radius: 5px;
  }
}
.alert-error-spot-redemption {
  font-size: var(--font-paragraph) !important;
  color: var(--color-error) !important;
  font-weight: 400 !important;
}
.card-alert-error {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: var(--spacing-extra-small);
  margin-top: var(--spacing-small);
  padding: var(--spacing-small) 0;
  border-radius: var(--border-radius-primary);
  color: var(--color-neutral-light);
  font-size: var(--font-paragraph);
  font-weight: 400;
}
.counter-text-area-modal {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: var(--font-paragraph) !important;
  color: var(--color-neutral-dark-lighter) !important;
  font-weight: 400 !important;
  font-family: var(--font-family) !important;
}
.card-total-edit-redemption {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-primary) !important;
  border: 1px solid var(--color-neutral-light-lighter);
  background-color: var(--color-neutral-light-lighter);
  cursor: auto;
}
.card-total-edit-redemption .vert-product-table-spot-value {
  text-transform: uppercase;
  font-size: var(--font-paragraph);
  font-weight: 500;
  line-height: 24px;
  color: var(--color-neutral-dark-darker);
}
.card-total-edit-redemption .vert-total-value-spot-typograph {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--spacing-extra-small);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/newSolicitationSpot/newSolicitationSpot.less"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,oCAAA;AACF;AAEA;EACE,gBAAA;AAAF;AAGA;EACE,aAAA;AADF;AAIA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAFF;AANA;EAWI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,gBAAA;AAHJ;AAdA;EAoBM,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAHN;AAtBA;EA8BI,gBAAA;AALJ;AASA;EACE;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,SAAA;EAPF;AACF;AAUA;EAGM,eAAA;EACA,mBAAA;EACA,wBAAA;AAVN;AAeA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AAbF;AAgBA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;EACA,2CAAA;EACA,aAAA;AAdF;AAiBA;EAKU,YAAA;AAnBV;AAcA;EAQY,6BAAA;AAnBZ;AAWA;EAac,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AArBd;AA8BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,oCAAA;EACA,4CAAA;EACA,2CAAA;EACA,+DAAA;EACA,6BAAA;AA5BF;AA+BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,4CAAA;EACA,2CAAA;EACA,+DAAA;EACA,6BAAA;AA7BF;AAqBA;EAYM,gBAAA;EACA,6BAAA;AA9BN;AAmCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,oCAAA;EACA,6BAAA;EACA,yBAAA;AAjCF;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AAlCF;AA8BA;EAOI,UAAA;EACA,eAAA;EACA,eAAA;AAlCJ;AAsCA;EACE,mBAAA;AApCF;AAuCA;EACE,eAAA;EACA,6BAAA;AArCF;AAwCA;EACE,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AAtCF;AAkCA;EAQM,4BAAA;EACA,wBAAA;AAvCN;AA8BA;EAaM,WAAA;EACA,YAAA;EACA,iCAAA;AAxCN;AA0CM;EACE,UAAA;EACA,WAAA;EAEA,iCAAA;EACA,oCAAA;EACA,8BAAA;EACA,8BAAA;AAzCR;AA+CA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AA7CF;AAgDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AA9CF;AAiDA;EACE;IACE,sBAAA;IACA,SAAA;EA/CF;AACF;AAkDA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;AAhDF;AAkDE;EAAA;IACE,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,QAAA;EA/CF;AACF;AAkDA;EACE,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAhDF;AAmDA;EACE;IACE,sBAAA;IACA,SAAA;EAjDF;AACF;AAoDA;EACE,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2CAAA;EACA,qCAAA;EACA,iCAAA;EACA,kBAAA;AAlDF;AA0CA;EAWI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,0BAAA;EACA,eAAA;EACA,wBAAA;EACA,6BAAA;EACA,oBAAA;EACA,UAAA;EAEA,+BAAA;EACA,gCAAA;EACA,iCAAA;AAnDJ;AA4BA;EA2BI,+BAAA;EACA,gCAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;AApDJ;AAqBA;EAkCM,yBAAA;AApDN;AAkBA;EAuCI,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gCAAA;EACA,+BAAA;EACA,gCAAA;AAtDJ;AAwDI;EACE,cAAA;EACA,gBAAA;AAtDN;AA2DA;;EAEE,mDAAA;EACA,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;AAzDF;AA2DE;;EACE,cAAA;AAxDJ;AA4DA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AA1DF;AA6DA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,8BAAA;AA3DF;AA8DA;EACE;IACE,aAAA;IACA,kBAAA;EA5DF;AACF;AAiEA;EACE,2CAAA;EACA,oCAAA;EACA,2BAAA;AA/DF;AAiEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,+BAAA;EACA,gCAAA;EACA,+BAAA;EACA,2CAAA;EACA,iCAAA;EACA,gCAAA;EACA,gBAAA;AA/DF;AAmEA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,mDAAA;EACA,2BAAA;EACA,0CAAA;AAjEF;AAoEA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,+BAAA;EACA,sDAAA;EACA,oDAAA;EACA,oDAAA;EACA,YAAA;AAlEF;AAyDA;EAYI,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;AAlEJ;AAkDA;EAoBI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;AAnEJ","sourcesContent":[".icon-participant {\n  display: inline-flex;\n  align-self: flex-start;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 4px;\n  margin-right: 12px;\n  font-size: var(--font-big);\n  color: var(--color-highlight-darker);\n}\n\n.icon-check {\n  font-size: 100px;\n}\n\n.select-disabled-spot {\n  display: none;\n}\n\n.result-success-spot {\n  font-size: 24px;\n  font-weight: 400;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  height: 100%;\n\n  .result-success-spot__content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    max-width: 600px;\n\n    .result-success-spot__description {\n      font-size: 16px;\n      font-weight: 500;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n\n  .result-success-spot__button {\n    margin-top: 20px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .box_content-sucess-spot {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n.result-success-spot {\n  .result-success-spot__content {\n    .result-success-spot__description {\n      font-size: 14px;\n      text-align: justify;\n      text-justify: inter-word;\n    }\n  }\n}\n\n.vert-title-form-title {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n}\n\n.box-product-spot {\n  margin-top: 10px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid var(--color-neutral-light);\n  border-radius: var(--border-radius-primary);\n  padding: 14px;\n}\n\n.spot-page-datepicker {\n  .ant-picker-panel-container {\n    .ant-picker-panel-layout {\n      .ant-picker-panel {\n        .ant-picker-date-panel {\n          width: 290px;\n\n          .ant-picker-body {\n            padding: var(--spacing-small);\n          }\n\n          .ant-picker-header {\n            .ant-picker-header-view {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              gap: var(--spacing-extra-small);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.box-value-spot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: var(--spacing-extra-small) 0;\n  border: 1px solid var(--color-neutral-light);\n  border-radius: var(--border-radius-primary);\n  background-color: var(--color-neutral-light-lighter) !important;\n  padding: var(--spacing-small);\n}\n\n.box-value-hierarchy {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  border: 1px solid var(--color-neutral-light);\n  border-radius: var(--border-radius-primary);\n  background-color: var(--color-neutral-light-lighter) !important;\n  padding: var(--spacing-small);\n\n  .shipping-value {\n    .free {\n      font-weight: 500;\n      color: var(--color-highlight);\n    }\n  }\n}\n\n.box-buttons-spot-submit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: var(--spacing-extra-small) 0;\n  padding: var(--spacing-small);\n  gap: var(--spacing-small);\n}\n\n.box-inputs {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n\n  .error {\n    color: red;\n    font-size: 12px;\n    margin-top: 4px;\n  }\n}\n\n.box-graft {\n  margin-bottom: 62px;\n}\n\n.box-show-endereco-entrega-spot {\n  margin: 6px 0px;\n  row-gap: var(--spacing-small);\n}\n\n.vert-radio.ant-radio-wrapper {\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n  font-size: var(--font-paragraph);\n\n  .ant-radio {\n    + span {\n      margin-top: unset !important;\n      height: unset !important;\n    }\n\n    .ant-radio-inner {\n      width: 16px;\n      height: 16px;\n      border-width: var(--border-width);\n\n      &::after {\n        width: 8px;\n        height: 8px;\n\n        border-width: var(--border-width);\n        background-color: #25cc6e !important;\n        transform: scale(1) !important;\n        border-radius: 50px !important;\n      }\n    }\n  }\n}\n\n.vert-modal-product-spot {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.vert-modal-product-spot__footer {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n@media screen and (max-width: 768px) {\n  .vert-modal-product-spot__footer {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n.vert-product-table-spot {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 5px;\n\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 5px;\n  }\n}\n\n.vert-product-table-spot-value {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n@media screen and (max-width: 768px) {\n  .vert-modal-product-spot__footer {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n.vert-input-number-spot {\n  height: 40px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  border-radius: var(--border-radius-primary);\n  border: 1px solid var(--color-border);\n  padding: 4px var(--spacing-small);\n  position: relative;\n\n  .shrink-label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 8px 16px 4px 16px;\n    font-size: 12px;\n    transform: translateY(0);\n    transition: all 0.3s ease-out;\n    line-height: inherit;\n    z-index: 2;\n\n    font-family: var(--font-family);\n    font-size: var(--font-paragraph);\n    color: var(--color-neutral-light);\n  }\n\n  .vert-input-label-spot {\n    font-family: var(--font-family);\n    font-size: var(--font-paragraph);\n    color: var(--color-neutral-light);\n    display: flex;\n    align-items: center;\n\n    .asterisk {\n      color: var(--color-error);\n    }\n  }\n\n  input {\n    width: 100%;\n    height: 100%;\n    border: none;\n    outline: none;\n    padding-top: 24px;\n    color: var(--color-neutral-dark);\n    font-family: var(--font-family);\n    font-size: var(--font-paragraph);\n\n    &::placeholder {\n      color: #d5d5e7;\n      font-weight: 500;\n    }\n  }\n}\n\n.vert-input-container input:disabled,\n.vert-input-container:disabled {\n  background-color: var(--color-neutral-light-darker);\n  border: none;\n  color: var(--color-button-text);\n  cursor: not-allowed;\n  overflow: hidden;\n\n  &::placeholder {\n    color: #b9bece;\n  }\n}\n\n.vert-select-fornecedor {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.div-button-fornecedor-spot {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin: var(--spacing-small) 0;\n}\n\n@media (max-width: 768px) {\n  .box-product-spot {\n    padding: 10px;\n    border-radius: 5px;\n  }\n}\n\n\n\n.alert-error-spot-redemption {\n  font-size: var(--font-paragraph) !important;\n  color: var(--color-error) !important;\n  font-weight: 400 !important;\n}\n.card-alert-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-extra-small);\n  margin-top: var(--spacing-small);\n  padding: var(--spacing-small) 0;\n  border-radius: var(--border-radius-primary);\n  color: var(--color-neutral-light);\n  font-size: var(--font-paragraph);\n  font-weight: 400;\n}\n\n\n.counter-text-area-modal{\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  font-size: var(--font-paragraph) !important;\n  color: var(--color-neutral-dark-lighter) !important;\n  font-weight: 400 !important;\n  font-family: var(--font-family) !important;\n}\n\n.card-total-edit-redemption {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-regular);\n  border-radius: var(--border-radius-primary) !important;\n  border: 1px solid var(--color-neutral-light-lighter);\n  background-color: var(--color-neutral-light-lighter);\n  cursor: auto;\n\n  .vert-product-table-spot-value {\n    text-transform: uppercase;\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n    line-height: 24px;\n    color: var(--color-neutral-dark-darker);\n  }\n\n  .vert-total-value-spot-typograph {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: var(--spacing-extra-small);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
